import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { ErrorKeys } from 'consts/errorKeys'

export interface IErrorPopupActions {
  primary: { labelKey: T; onClick: () => void }
  secondary?: { labelKey: T; onClick: () => void }
}

export interface IErrorPopupData {
  title?: string
  description?: string
  actions?: IErrorPopupActions
}

export const getDataByType = (
  type: ErrorKeys,
  { onClose, onUpgrade }: { onClose: () => void; onUpgrade?: () => void } = {
    onClose: () => {}
  }
): IErrorPopupData => {
  const defaultActions: IErrorPopupActions = {
    primary: { labelKey: T.GOT_IT_LABEL, onClick: onClose }
  }

  const upgradeActions: IErrorPopupActions = {
    primary: { labelKey: T.UPGRADE, onClick: onUpgrade ?? onClose },
    secondary: { labelKey: T.TRY_AGAIN_LATER, onClick: onClose }
  }

  return (
    {
      [ErrorKeys.NOT_FOUND_PROJECT]: {
        title: translate(T.SOMETHING_WENT_WRONG_LABEL),
        description: translate(T.NOT_FOUND_PROJECT_ERROR_MESSAGE),
        actions: defaultActions
      },
      [ErrorKeys.GENERAL_API_ERROR]: {
        title: translate(T.SOMETHING_WENT_WRONG_LABEL),
        description: translate(T.GENERAL_API_ERROR_MESSAGE),
        actions: defaultActions
      },
      [ErrorKeys.PROJECT_MAX_DURATION_EXCEEDED]: {
        title: translate(T.PROJECT_MAX_DURATION_EXCEEDED_TITLE),
        description: translate(T.PROJECT_MAX_DURATION_EXCEEDED_DESCRIPTION),
        actions: defaultActions
      },
      [ErrorKeys.AI_VIDEO_GENERATION_FAILED]: {
        title: translate(T.AI_VIDEO_GENERATION_FAILED_TITLE),
        description: translate(T.AI_VIDEO_GENERATION_FAILED_DESCRIPTION),
        actions: defaultActions
      },
      [ErrorKeys.AI_IMAGE_GENERATION_FAILED]: {
        title: translate(T.GENERATION_FAILED),
        description: translate(T.AI_IMAGE_GENERATION_FAILED_DESCRIPTION),
        actions: defaultActions
      },
      [ErrorKeys.AI_MODERATION_FAILED]: {
        title: translate(T.AI_MODERATION_FAILED_TITLE),
        description: translate(T.AI_MODERATION_FAILED_DESCRIPTION),
        actions: defaultActions
      },
      [ErrorKeys.AI_VIDEO_TEMPORARILY_UNAVAILABLE]: {
        title: translate(T.AI_VIDEO_TEMPORARILY_UNAVAILABLE_TITLE),
        description: translate(T.AI_VIDEO_TEMPORARILY_UNAVAILABLE_DESCRIPTION),
        actions: upgradeActions
      },
      [ErrorKeys.AI_AVATAR_GENERATION_FAILED]: {
        title: translate(T.GENERATION_FAILED),
        description: translate(T.AI_AVATAR_GENERATION_FAILED_DESCRIPTION),
        actions: defaultActions
      },
      [ErrorKeys.CUSTOM_API_ERROR]: {
        title: translate(T.SOMETHING_WENT_WRONG_LABEL),
        actions: defaultActions
      },
      // No description — the backend's own limit message is passed through
      // handleApiError and shown verbatim (description || message fallback).
      [ErrorKeys.PROJECT_DRAFT_LIMIT_REACHED]: {
        title: translate(T.PROJECT_DRAFT_LIMIT_REACHED_TITLE),
        actions: {
          primary: { labelKey: T.UPGRADE, onClick: onUpgrade ?? onClose },
          secondary: { labelKey: T.GOT_IT_LABEL, onClick: onClose }
        }
      }
    }[type] ?? { actions: defaultActions }
  )
}
